import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from 'react-redux';
import { capitalizeFirstLetter, getDefaultScale, hit, intersectRect, isEmpty, removeUnderscore } from "../../../../utils/common";
import { Button, Modal, ModalHeader, ModalBody, Input } from 'reactstrap';
import { updateDocumentIsCorrect } from "../../../../context/actions/document";
import LoaderUI from "../../../../components/common/loader";
import './index.scss'
import { AsyncPaginate } from "react-select-async-paginate";
import { tagSearchAction } from "../../../../context/actions/tagSearch";
import { maxScaleValue } from "../../../../utils/constants";
import moment from "moment";
import TimezoneClock from "../../../../components/common/TimeZone";
toast.configure();


const DocumentFileView = ({/*setDisable,*/idleScale, _xmlTags, pdf, pageNumber, jsonMetaData, xmlMeta, setXmlMeta, saveversion, setAddXmlTag, _zoomOcr, _zoomFlag, _priorityFlag, _refresh, _zoomInOcr, _zoomOutOcr, scale, activeLink, disabledZoomOutButton, disabledZoomInButton, disabledZoomFlag, _activeEditTabs, _activeTab, _currentVersion, unableToValidate }) => {

  // const scale = 1.5;
  // const scale = 1;
  // console.log(idleScale, scale, "vvvvvvvvvvvv")
  //  scale = idleScale > scale ? idleScale : scale

  const [canvasContext, setCanvasContext] = useState();
  const [docScale, setDocScale] = useState();
  const [canvasDocView, setCanvasDocView] = useState(null);
  const [tipCanvas, setTipCanvas] = useState();
  const [tipCtx, setTipCtx] = useState();
  const [xmlTags, setXmlTags] = useState([]);
  const [ocrScale, setOcrScale] = useState();
  const [ocrScaleHeight, setOcrScaleHeight] = useState();
  const [ocrJsonScaleHeight, setOcrJsonScaleHeight] = useState();
  const [ocrJsonScale, setOcrJsonScale] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [editXmlTag, setEditXmlTag] = useState(null);
  const [tagValue, setTagValue] = useState("");
  const [originalTagValue, setOriginalTagValue] = useState("");
  const [loader, setLoader] = useState(false);
  const [focus, setFocus] = useState(false)
  const [disableButton, setDisableButton] = useState(true);
  const [isTagUpdated, setIsTagUpdated] = useState(false);
  const [existingTagBounds, setExistingTagBounds] = useState(null);
  const [unacceptedTags, setUnacceptedTags] = useState(0);
  const [isInsertTag, setIsInserttag] = useState(false);
  let [height, setHeight] = useState(null);
  const dispatch = useDispatch();
  const data = useSelector((state) => state.document.fileData);
  let xmlMetaDetailObject = useSelector((state) => state.document.xmlMeta);
  let fileSetting = useSelector((state) => state?.fileSetting?.data); // get previously filter value
  const files = useSelector((state) => state?.document?.docRecords);
  const fileVersions = useSelector((state) => state.document.fileVersions || []);
  const fileData = useSelector((state) => state.document.fileData);
  const [latestFileVersion, setLatestFileVersion] = useState(fileData?.fileVersions?.[fileVersions.length - 1]);
  const latestVersion = useSelector((state) => state.document.latestVersion);
  let xmin = useSelector((state) => state.document?.fileData?.multi_loan_identifier?.xmin);
  let xmax = useSelector((state) => state.document?.fileData?.multi_loan_identifier?.xmax);
  let y = useSelector((state) => state.document?.fileData?.multi_loan_identifier?.y);
  const is_multi_loan = useSelector((state) => state.document?.fileData?.is_multi_loan);
  console.log('is_multi_loan',is_multi_loan);


  let [documentUpdated, setDocumentUpdated] = useState(true);
  const canvasRefDoc = useRef(null);
  const [canvas, setCanvas] = useState(null);
  const isAdminLoggedIn = useSelector(state => state?.user?.user?.isAdminLoggedIn)

  // let confidence = fileSetting.find((item) => {
  //   if (item.title === 'aggregator_logo_confidence') {
  //     return item;
  //   }
  // });
  let confidence = fileData?.confidence_range?.aggregator_logo_confidence;
  const userDetail = useSelector((state) => state?.user?.user);

  // const [auditLogTag, setAuditLogTag] = useState('');



  useEffect(() => {

    (async () => {
      // console.log("11111111111111111111111")
      if (documentUpdated) {
        if (pdf?.img)
          await decodeImg(pdf)
        else
          await decodePdf(pdf);

        if (!isEmpty(jsonMetaData) && xmlTags.length > 0 && canvasContext && docScale) {
          await boundsDraw();
        }

      }

    })();
  }, [pageNumber,/*xmlTags,*/documentUpdated, xmlTags]);
  useEffect(() => {
    
    (async () => {
      // console.log("2222222222222222222")
      // setLoader(true)
      if (documentUpdated) {
        if (pageNumber == 1) {
          setLoader(false)
        }
        else {
          // setLoader(true)
        }
        if (pdf?.img)
          await decodeImg(pdf)
        else
          await decodePdf(pdf);

        if (!isEmpty(jsonMetaData) && !isEmpty(xmlTags) && canvasContext && docScale) {
          await boundsDraw();
        }
        setLoader(false)

        
      }

    })();

  }, [pdf, pageNumber, documentUpdated]);


  useEffect(() => {
    // console.log("33333333333333333333")
    if (documentUpdated) {
      setTimeout(() => {
        if (!isEmpty(jsonMetaData) && !isEmpty(xmlTags) && canvasContext && docScale) {
          boundsDraw();
        }
      }, 100);
    }

  }, [canvasContext, docScale, documentUpdated]);

  useEffect(() => {
    // console.log("44444444444444444444444444444")
    if (documentUpdated) {
      if (canvasDocView) {
        enventRect()
      }
    }

  }, [/*canvasDocView*/, xmlTags, xmlMeta, latestVersion, documentUpdated])

  useEffect(() => {
    // console.log("55555555555555555555555555555555555555")
    if (documentUpdated) {
      if (canvasContext) {
        enventRect()
        eveluateXML()

      }
    }

  }, [xmlMeta,canvasContext, isTagUpdated, documentUpdated,/*setDisable*/])
  /** in the above useEffect xmlMeta is added in the array to update doc-view tags whaen we change in ocr-view tags------*/

  useEffect(() => {
    if (documentUpdated) {
      // console.log("666666666666666666666666666")
      if (tagValue) {
        // loadOptions()
        setFocus(false)
      }
    }

  }, [tagValue, documentUpdated])

  useEffect(() => {
    // console.log("177777777777777777777777777777777")
    eveluateXML()


  }, [isInsertTag])

  // useEffect(() => {
  //   if (docScale && ocrScaleHeight) {

  //     console.log(docScale, ocrScaleHeight, "checkingdocScale, ocrScaleHeight--->>")
  //     eveluateXML()
  //   }

  // }, [docScale, ocrScaleHeight]);



  // useEffect(() => {
  //   if (tipCtxDocView) {
  //     enventRect()
  //   }
  // }, [tipCtxDocView])
  useEffect(() => {
    if (_zoomOcr) {
      // console.log("888888888888888888888888888888888888")
      zoomInPdfOcrView()
    }

  }, [_zoomOcr, _priorityFlag])

  const zoomInPdfOcrView = async () => {

    if (_activeTab == 2) {
      setCanvasContext();
      setOcrScale();
      setXmlTags([]);
      if (pdf?.img)
        await decodeImg(pdf);
      else
        await decodePdf(pdf);
      enventRect();
    }

  }

  /**
   * @description Function calculating bounds height and width
   * @param {Number} value accepting number value
   * @returns return number value
   */
  const calc = (value) => (value < 0 ? value * -1 : value);

  /**
    * @description func for calculateing scale
    * @param {*} itam coordinates
    * @returns number
    */
  const scaleCal = (item) => (Number(item) / Number(docScale))

  const scaleCalHeight = (item) => {
    // console.log(item, ocrScaleHeight, "chekign ocrScaleHeight--->>")
    return (Number(item) / Number(ocrScaleHeight))
  }

  /**
    * @description func for calculateing scale
    * @param {*} itam coordinates
    * @returns number
    */
  const scaleJsonCal = (item) => {
    // console.log(item, ocrJsonScale, "checking ocrJsonScale-------->>>>>>>>>")
    return (Number(item) / Number(ocrJsonScale))
  }
  const scaleJsonCalHeight = (item) => {
    // console.log(item, ocrJsonScaleHeight, "checking ocrJsonScaleHeight------->>>>>>")
    return (Number(item) / Number(ocrJsonScaleHeight))
  }


  const boundsDrawOld = async () => {
    // console.log(jsonMetaData, "chekcking jsonMetaData in bounds draw")
    let key;

    for (var i = 0; i < jsonMetaData?.text.length; i++) {

      // if (jsonMetaData?.isline[i] == true) {
      //   key = jsonMetaData?.text[i].split(":")[0]
      // }

      // if (jsonMetaData?.isline[i] != true && !jsonMetaData?.text[i].includes(":") && !key.includes(jsonMetaData?.text[i])) {

      canvasContext.strokeStyle = "#008000";
      canvasContext.setLineDash([2]);
      canvasContext.strokeRect(
        jsonMetaData.left[i] / docScale,
        jsonMetaData.top[i] / docScale,
        jsonMetaData.width[i] / docScale,
        jsonMetaData.height[i] / docScale
      );

      // }
      // if (jsonMetaData?.text[i].includes(":")) {
      //   isLineTrueIndex = false;
      // }
      // console.log(i, isLineTrueIndex, colonIncludesIndex, "checking isLineTrueIndex--->>>>>")
      // let xml = {
      //   bndbox: {
      //     x: { _text: scaleJsonCal(jsonMetaData.left[i]) }, // scaleJsonCal function use to set zoom in/out coordinates
      //     y: { _text: scaleJsonCalHeight(jsonMetaData.top[i]) },
      //     //  y: scaleJsonCal(jsonMetaData.top[i]),
      //     w: { _text: scaleJsonCal(jsonMetaData.width[i]) },
      //     h: { _text: scaleJsonCalHeight(jsonMetaData.height[i]) },

      //     /*xmax: scaleJsonCal(jsonMetaData.left[i]),
      //     xmin: jsonMetaData.left[i] > jsonMetaData.width[i] ? scaleJsonCal(jsonMetaData.left[i])-scaleJsonCal(jsonMetaData.width[i]) : scaleJsonCal(jsonMetaData.width[i]) - scaleJsonCal(jsonMetaData.left[i]),
      //     ymax:scaleJsonCalHeight(jsonMetaData.top[i]),
      //     ymin:jsonMetaData.top[i] > jsonMetaData.height[i] ? scaleJsonCalHeight(jsonMetaData.top[i])-scaleJsonCalHeight(jsonMetaData.height[i]) : scaleJsonCalHeight(jsonMetaData.height[i]) - scaleJsonCalHeight(jsonMetaData.top[i]),*/

      //     /* given xmin is starting point and x max is the width-17Jan-22*/
      //     xmin: { _text: scaleJsonCal(jsonMetaData.left[i]) },
      //     xmax: { _text: + scaleJsonCal(jsonMetaData.left[i]) + scaleJsonCal(jsonMetaData.width[i]) },
      //     ymin: { _text: scaleJsonCalHeight(jsonMetaData.top[i]) },
      //     ymax: { _text: + scaleJsonCalHeight(jsonMetaData.top[i]) + scaleJsonCalHeight(jsonMetaData.height[i]) },
      //   },
      //   changesViaVersion: {
      //     _text: "11"
      //   },
      //   confidence: {
      //     _text: "\n   0.9974746108055115\n  "
      //   },
      //   name: {
      //     _text: "\n   aggregator_loan_number\n  "
      //   },
      //   updatedAt: {
      //     _text: "2023-01-24T04:36:45.048Z"
      //   },
      //   updatedName: {
      //     _text: "new_seller_bank_account_number"
      //   },
      //   overlap: [
      //     {
      //       x: scaleJsonCal(jsonMetaData.left[i]),
      //       y: scaleJsonCalHeight(jsonMetaData.top[i]),
      //       w: scaleJsonCal(jsonMetaData.width[i]),
      //       h: scaleJsonCalHeight(jsonMetaData.height[i]),
      //       xmin: scaleJsonCal(jsonMetaData.left[i]),
      //       xmax: + scaleJsonCal(jsonMetaData.left[i]) + scaleJsonCal(jsonMetaData.width[i]),
      //       ymin: scaleJsonCalHeight(jsonMetaData.top[i]),
      //       ymax: + scaleJsonCalHeight(jsonMetaData.top[i]) + scaleJsonCalHeight(jsonMetaData.height[i]),
      //       text: "-300.55",
      //       confidence: 0.983,
      //       updatedAt: false,
      //       isAccepted: false,
      //       isDraft: false,
      //       draftText: false,
      //       changesViaVersion: "",
      //       id: "2315-1105",
      //       pageId: "2315-1105-1",
      //       intersectedArea: 1.2499999999999958
      //     }
      //   ]
      // }


      // xmlMeta.annotation.object.push(xml)

    }

    if (is_multi_loan) {
      multiLoanBoundaries();
    }


  }


  const boundsDraw = async () => {
    // console.log(xmlTags, "chekcking jsonMetaData in bounds draw")
    let key;

    for (let i = 0; i < xmlTags.length; i++) {
      canvasContext.strokeStyle = "#008000";
      canvasContext.setLineDash([2]);
      canvasContext.strokeRect(
        xmlTags[i].bounds.x,
        xmlTags[i].bounds.y,
        xmlTags[i].bounds.w,
        xmlTags[i].bounds.h
      );
    }

    for (let i = 0; i < jsonMetaData?.text.length; i++) {
      let isInsideBoundry = false
      let xco = {
        x: Number(jsonMetaData.left[i]), // scaleJsonCal function use to set zoom in/out coordinates
        y: Number(jsonMetaData.top[i]),
        w: Number(jsonMetaData.width[i]),
        h: Number(jsonMetaData.height[i]),
        text: jsonMetaData.text[i]
      }

      for (let j = 0; j < xmlTags.length; j++) {
        let isTextExist = xmlTags[j].overlap.findIndex((jsonData) => { return jsonData.text == xco.text });
        if (isTextExist != -1) {
          isInsideBoundry = true;
          break;
        }
      }
      if (!isInsideBoundry) {
        canvasContext.strokeStyle = "#008000";
        canvasContext.setLineDash([2]);
        canvasContext.strokeRect(
          jsonMetaData.left[i] / docScale,
          jsonMetaData.top[i] / docScale,
          jsonMetaData.width[i] / docScale,
          jsonMetaData.height[i] / docScale
        );
      }


    }

    if (is_multi_loan) {
      multiLoanBoundaries();
    }


  }




  /**
  * @description method call for drow boundary with dotted lines
  * @param {*} rect  rectange
  */
  const multiLoanBoundaries = (rect, hilighitFlg = false) => {


    // console.log('aaaaaaaa->')
    if (canvasContext) {
      // console.log('aaaaaaab->',xmin,xmax,height)

      canvasContext.strokeStyle = "grey";
      canvasContext.lineWidth = 2.5;
      canvasContext.strokeRect(scaleJsonCal(xmin - 10), scaleJsonCal(y), scaleJsonCal(xmax - xmin), height)



    }
  }

  /**
   * This function is used to add new tag manually into existing tags from document view
   * @param {newTag} 
   * @returns add new tag into xmlTags
   */
  let insertNewTag = (tag) => {
    // console.log('insertNewTag hitting', tag);

    // console.log(xml, xmlMetaDetailObject, "checking xml in function---->>>>")
    if (tagValue.length == 0) {
      // alert("enter valid tag")
      toast.error("Enter Valid Tag")
    }
    else {

      setLoader(true)
      let newTag = tagValue.split(' ').join('_').toLocaleLowerCase()
      // console.log(fileData?.version, tag, docScale, "fileData?.version")
      let xml = {
        // bndbox: {
        //   xmin: { _text: `\n   ${tag.xmin._text} \n ` },
        //   xmax: { _text: `\n   ${tag.xmax._text} \n ` },
        //   ymin: { _text: `\n   ${tag.ymin._text} \n ` },
        //   ymax: { _text: `\n   ${tag.ymax._text} \n ` },
        // },
        bndbox: {
          xmin: { _text: `\n    ${Math.round(tag.xmin / Number(scale))}\n   ` },
          xmax: { _text: `\n    ${Math.round(tag.xmax / Number(scale))}\n   ` },
          ymin: { _text: `\n    ${Math.round(tag.ymin / Number(scale))}\n   ` },
          ymax: { _text: `\n    ${Math.round(tag.ymax / Number(scale))}\n   ` },
        },

        confidence: {
          _text: "\n   0.9974746108055115\n  "
        },
        name: {
          _text: `\n   ${newTag}\n `
        },
        updatedAt: {
          _text: new Date().toISOString()
        },
        updatedName: {
          _text: `\n   ${newTag}\n `
        },
        // changesViaVersion: {
        //   _text: `\n ${Number(fileData?.version) + 1}`
        // }
        changesViaVersion: Number(fileData?.version || 0) + 1
      }

      // for (let key in xmlMetaDetailObject) {

      let key = pageNumber;


      // console.log('key', key);
      console.log(xmlMetaDetailObject[key]?.annotation?.object, 'xmlMetaDetailObject-===')

      // let existingTagIndex = xmlMetaDetailObject[key]?.annotation?.object.findIndex((item) => { return item.bndbox.xmax._text == tag.xmax._text && item.bndbox.xmin._text == tag.xmin._text && item.bndbox.ymax._text == tag.ymax._text && item.bndbox.ymin._text == tag.ymin._text });
      let existingTagIndex = xmlMetaDetailObject[key]?.annotation?.object.findIndex((item) => { return Number(item.bndbox.xmax._text) == Number(xml.bndbox.xmax._text) && Number(item.bndbox.xmin._text) == Number(xml.bndbox.xmin._text) && Number(item.bndbox.ymax._text) == Number(xml.bndbox.ymax._text) && Number(item.bndbox.ymin._text) == Number(xml.bndbox.ymin._text) });
      // console.log('checking everything', xmlMetaDetailObject[key].annotation.object[existingTagIndex].name)
      // console.log(xml, existingTagIndex, "chekcing xml in push")
      console.log(existingTagIndex,xml.bndbox,xmlMetaDetailObject[key]?.annotation?.object[6], "checking existingTagIndex----")
      let savedTag = '';
      if (existingTagIndex != -1) {
        // console.log('', )



        // console.log('block running => if ')
        console.log(xmlMetaDetailObject[key].annotation.object[existingTagIndex], " xmlMetaDetailObject[key]-----")
        // console.log(existingTagIndex,tag,xmlMetaDetailObject, "checking existingTagIndex---- 11")
        // console.log(xmlMetaDetailObject[key].annotation?.object[existingTagIndex], existingTagIndex, "chhhhhh")
        // xmlMetaDetailObject[key].annotation.object[existingTagIndex].name = { _text: `\n   ${newTag}\n ` };
        xmlMetaDetailObject[key].annotation.object[existingTagIndex].updatedName = { _text: `\n   ${newTag}\n ` };
        xmlMetaDetailObject[key].annotation.object[existingTagIndex].updatedAt = { _text: new Date().toISOString() };
        xmlMetaDetailObject[key].annotation.object[existingTagIndex].changesViaVersion = Number(fileData?.version || 0) + 1;
        // const originalTag = tagValue;
        console.log('originalTag', originalTagValue, 'tagValue=>', tagValue);
        if(originalTagValue.trim() == tagValue.trim())
        {
          console.log('saturday block => if')
          savedTag = null;
        }else{
          console.log('saturday block => else')
          savedTag = originalTagValue;
        }
        // console.log('savedTag=>', savedTag) 
      }
      else {
        savedTag = tagValue;
        // console.log('savedTag=>', savedTag) 
        // console.log('block running => else')
        xmlMetaDetailObject[key].annotation.object.push(xml)

        // /** @start finding intersected text and updating unaccepted items according to their confidence */
        // console.log(xmlTags, "xmlTagsEveluted in document view")
        // let totalUnacceptedItems = 0;

        // for (let i = 0; i < xmlTags.length; i++) {
        //   for (let j = 0; j < xmlTags[i].overlap.length; j++) {
        //     if ((xmlTags[i].overlap[j].confidence <= cRedConfidence.end_range && xmlTags[i].overlap[j].confidence >= cRedConfidence.start_range)) {
        //       console.log(xmlTags[i].overlap[j].confidence, xmlTags[i].overlap[j].text, "this is confidence")
        //       totalUnacceptedItems += 1
        //     }
        //     console.log(xmlTags[i].overlap[j].confidence, cRedConfidence.start_range, cRedConfidence.end_range, "checking confidd")
        //   }
        // }

        // dispatch(updateDocumentIsCorrect({ unaccepted_items: totalUnacceptedItems, is_correct: 2, id: data?._id }, ((result) => {
        //   console.log(result, tag, "checking files from state----")
        // })));
        // console.log(totalUnacceptedItems, data, "checking totalUnacceptedItems")

        // /** @end */

        // if ((cRedConfidence.start_range <= tag.confidence <= cRedConfidence.end_range) || (cYellowConfidence.start_range <= tag.confidence <= cYellowConfidence.end_range)) {
        //   // console.log(cRedConfidence, cYellowConfidence, tag, "checking files from state----")
        //   dispatch(updateDocumentIsCorrect({ unaccepted_items: data.unaccepted_items + 1, is_correct: 2, id: data?._id }, ((result) => {
        //     console.log(result, tag, "checking files from state----")
        //   })));
        // }

      }

      // }


      // console.log(xmlMetaDetailObject, "checkign tagValue")
      setAddXmlTag(xml)
      setTagValue("")
      setDisableButton(true)
      setIsTagUpdated(true)
      saveversion(savedTag,(result) => {
        if (result) {
          setIsInserttag(!isInsertTag)
          eveluateXMLOnTagInsertion((updatedXmlTags) => {
            if (updatedXmlTags) {
              /* setDocumentUpdated(false)
 
               dispatch(updateDocumentIsCorrect({ id: data?._id }, ((result) => {
                 dispatch({ type: "DOCUMENT_DATA", data: result });
                 setDocumentUpdated(true)
               
 
               }))); */

              // console.log(updatedXmlTags, "checking xmlTags after saveing verdsuion")

              /** @start finding intersected text and updating unaccepted items according to their confidence */

              /* let totalUnacceptedItems = 0;
 
               for (let i = 0; i < updatedXmlTags.length; i++) {
                 for (let j = 0; j < updatedXmlTags[i].overlap.length; j++) {
                   if ((updatedXmlTags[i].overlap[j].confidence <= cRedConfidence.end_range && updatedXmlTags[i].overlap[j].confidence >= cRedConfidence.start_range)) {
                     console.log(updatedXmlTags[i].overlap[j].text, "checking unaccepted text")
                     totalUnacceptedItems += 1
                   }
 
                 }
               }
 
               dispatch(updateDocumentIsCorrect({ unaccepted_items: totalUnacceptedItems, is_correct: 2, id: data?._id }, ((result) => {
                 setUnacceptedTags(totalUnacceptedItems)
                 const lastItem = [...fileVersions].pop();
                 if (result?.unaccepted_items != result?.accepted_itms) {
                   dispatch({ type: "DOCUMENT_DATA", data: result });
 
                 }
 
               })));
 
               console.log(totalUnacceptedItems, "checking totalUnacceptedItems---") */
              /** @end */
            }
          })
          setIsTagUpdated(false);
          setTimeout(() => { setLoader(false); setOpenModal(false) }, 500)
          // setLoader(false);

        }
      })

      // setTimeout(() => { setLoader(false); setIsTagUpdated(false) }, 5000)



    }

  }


  /**
      * @description method call to set bounds with scale for XML eveluate 
      * @param {*} bouns rectange 
      * @returns 
      */
  const eveluateXMLBounds = async (bouns) => {
    let bounds = {
      x: scaleCal(bouns?.xmin?._text),
      y: scaleCalHeight(bouns?.ymin?._text),
      w: (scaleCal(bouns?.xmax?._text) - scaleCal(bouns?.xmin?._text)),
      h: (scaleCalHeight(bouns?.ymax?._text) - scaleCalHeight(bouns?.ymin?._text)),
      xmin: scaleCal(bouns?.xmin?._text),
      xmax: scaleCal(bouns?.xmax?._text),
      ymin: scaleCalHeight(bouns?.ymin?._text),
      ymax: scaleCalHeight(bouns?.ymax?._text)
    }
    return bounds
  }




  const boundsIsOverlap = async (xmlTg) => {
    let intesr = [];
    let flag = false;
  //  console.log('bound is overlap json meta data ->', jsonMetaData)
    for (var i = 0; i < jsonMetaData?.text.length; i++) {
      let xco = {
        x: scaleJsonCal(jsonMetaData.left[i]), // scaleJsonCal function use to set zoom in/out coordinates
        y: scaleJsonCalHeight(jsonMetaData.top[i]),
        w: scaleJsonCal(jsonMetaData.width[i]),
        h: scaleJsonCalHeight(jsonMetaData.height[i]),


        /* given xmin is starting point and x max is the width-17Jan-22*/
        xmin: scaleJsonCal(jsonMetaData.left[i]),
        xmax: + scaleJsonCal(jsonMetaData.left[i]) + scaleJsonCal(jsonMetaData.width[i]),
        ymin: scaleJsonCalHeight(jsonMetaData.top[i]),
        ymax: + scaleJsonCalHeight(jsonMetaData.top[i]) + scaleJsonCalHeight(jsonMetaData.height[i]),
        text: jsonMetaData.text[i],
        originalText: jsonMetaData.text[i],
        confidence: jsonMetaData.confidence[i],
     //   updatedAt: jsonMetaData?.updatedAt && jsonMetaData?.updatedAt[jsonMetaData.left[i] + ':' + jsonMetaData.top[i]] ? jsonMetaData?.updatedAt[jsonMetaData.left[i] + ':' + jsonMetaData.top[i]] : false, // set if any tags/text values updating to maintain logs
     // NOTE : earlier we were saving id by concating left and top xml values by a '-' but now we are saving them as ':', so both conditions are checked for matching both old and new
        isAccepted: jsonMetaData?.isAccepted && ( jsonMetaData?.isAccepted[jsonMetaData.left[i] + ':' + jsonMetaData.top[i]] || jsonMetaData?.isAccepted[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]]) ? true : false,
        isDraft: jsonMetaData?.isDraft && (jsonMetaData?.isDraft[jsonMetaData.left[i] + ':' + jsonMetaData.top[i]] || jsonMetaData?.isDraft[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]]) ? true : false,
        updatedAt: jsonMetaData?.updatedAt && (jsonMetaData?.updatedAt[jsonMetaData.left[i] + ':' + jsonMetaData.top[i]] || jsonMetaData?.updatedAt[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]]) ? (jsonMetaData?.updatedAt[jsonMetaData.left[i] + ':' + jsonMetaData.top[i]] || jsonMetaData?.updatedAt[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]]) : false,
        draftText: jsonMetaData?.draftText && (jsonMetaData?.draftText[jsonMetaData.left[i] + ':' + jsonMetaData.top[i]] || jsonMetaData?.draftText[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]] ) ? (jsonMetaData?.draftText[jsonMetaData.left[i] + ':' + jsonMetaData.top[i]] || jsonMetaData?.draftText[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]]): false,

        changesViaVersion: jsonMetaData?.changesViaVersion && ( jsonMetaData?.changesViaVersion[jsonMetaData.left[i] + ':' + jsonMetaData.top[i]] || jsonMetaData?.changesViaVersion[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]]) ? (jsonMetaData?.changesViaVersion[jsonMetaData.left[i] + ':' + jsonMetaData.top[i]] || jsonMetaData?.changesViaVersion[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]]) : '',

      }
      if (xco.confidence && intersectRect(xmlTg.bounds, xco)) { //identify intesect rectange xml/ json
        if (xmlTg.tag.indexOf('aggregator_logo') != -1) {

          if (xco.confidence >= confidence?.start_range && xco.confidence <= confidence?.end_range) {

            xco = { ...xco, id: `${jsonMetaData.left[i]}:${jsonMetaData.top[i]}`, pageId: `${jsonMetaData.left[i]}:${jsonMetaData.top[i]}:${pageNumber}` }
            intesr.push(xco);
            break;

          }
        } else {
          xco = { ...xco, id: `${jsonMetaData.left[i]}:${jsonMetaData.top[i]}`, pageId: `${jsonMetaData.left[i]}:${jsonMetaData.top[i]}:${pageNumber}` }
          intesr.push(xco)

        }

      }


    }
    // console.log('==> intesr in doc view ==>', intesr)

    return { intesr, flag }

  }

  const eveluateXMLOnTagInsertion = async (cb) => {
    let xmlTagsEveluted = [];
    if (!xmlMeta?.annotation?.object.length) {
      let value = xmlMeta?.annotation?.object;
      xmlMeta.annotation.object = [];
      xmlMeta.annotation.object.push(value)
    }
    let tempNewObject;
    for (var i = 0; i < xmlMeta?.annotation.object.length; i++) {

      if (is_multi_loan) {
        // console.log('xmlMeta?.annotation.object[i].bndbox',xmlMeta?.annotation.object[i].bndbox)


        if (xmin <= xmlMeta?.annotation.object[i].bndbox.xmin._text && xmlMeta?.annotation.object[i].bndbox.xmax._text <= xmax && y <= xmlMeta?.annotation.object[i].bndbox.ymax._text) {


          let newObj = {
            id: `${xmlMeta?.annotation?.object[i]?.name._text}:${i}`, // this id use to maintain while fouse on any files hilight bounds on same index
            updatedAt: xmlMeta?.annotation.object[i]?.updatedAt || false,
            changesViaVersion: xmlMeta?.annotation.object[i]?.changesViaVersion || false,
            tagId: `${i}:${pageNumber}`,
            tag: xmlMeta?.annotation?.object[i]?.updatedName?._text ? xmlMeta?.annotation.object[i].updatedName._text : xmlMeta?.annotation?.object[i]?.name?._text,
            isDraft: xmlMeta?.annotation?.object[i]?.draftUpdatedName?._text ? xmlMeta?.annotation?.object[i]?.draftUpdatedName?._text : false,
            bounds: await eveluateXMLBounds(xmlMeta?.annotation?.object[i]?.bndbox)// evaluate height,width, xmin and ymin coordinates
          }

          let { intesr, flag } = await boundsIsOverlap(newObj);// compare overlap bounds with json 

          let box_A = [newObj.bounds.xmin, newObj.bounds.ymin, newObj.bounds.xmax, newObj.bounds.ymax]

          for (let subbLp = 0; subbLp < intesr.length; subbLp++) { 
            let box_B = [intesr[subbLp].xmin, intesr[subbLp].ymin, intesr[subbLp].xmax, intesr[subbLp].ymax]
            let x_low = Math.max(box_A[0], box_B[0])
            let y_low = Math.max(box_A[1], box_B[1])
            let x_high = Math.min(box_A[2], box_B[2])
            let y_high = Math.min(box_A[3], box_B[3])
            let inter_area = Math.max(0, x_high - (x_low + 1)) * Math.max(0, y_high - y_low + 1)
            let box_B_area = (box_B[2] - (box_B[0] + 1)) * (box_B[3] - (box_B[1] + 1))
            let intersectedArea = inter_area / box_B_area
            intesr[subbLp].intersectedArea = intersectedArea



          }



          for (let k = 0; k < tempNewObject?.overlap?.length; k++) {
            let newInd = intesr.findIndex((item) => item.text === tempNewObject?.overlap[k].text)

            if (newInd > -1) {
              // console.log("intersection point matched --->", tempNewObject.overlap[k].intersectedArea, intesr[newInd])
              if (tempNewObject.overlap[k].intersectedArea < 0.5) {
                tempNewObject.overlap.splice(k, 1)
              }
              if (intesr[newInd].intersectedArea < 0.5) {
                intesr.splice(newInd, 1)
              }
            }
          }

          newObj.overlap = intesr;
          let flag1 = true
          // for (var z = 0; z < xmlTagsEveluted?.length; z++) {

          //   let intersectdata = xmlTagsEveluted[z] && xmlTagsEveluted[z].overlap.filter(item => item.id === intesr[0]?.id);
          //   if (intersectdata && intersectdata.length > 0) {
          //     flag1 = false

          //   }
          // }
          if (flag1) {

            if (xmlTagsEveluted.length > 1) {
              xmlTagsEveluted[xmlTagsEveluted.length - 1] = tempNewObject
            }
            xmlTagsEveluted.push(newObj);
          }
          else {
            xmlTagsEveluted.push(newObj);
          }
          if (flag1 == false) {
            // console.log('value is false', newObj)
            // break;
          }
          tempNewObject = newObj
        }
      } else {
        let newObj = {
          id: `${xmlMeta?.annotation?.object[i]?.name._text}:${i}`, // this id use to maintain while fouse on any files hilight bounds on same index
          updatedAt: xmlMeta?.annotation.object[i]?.updatedAt || false,
          changesViaVersion: xmlMeta?.annotation.object[i]?.changesViaVersion || false,
          tagId: `${i}:${pageNumber}`,
          tag: xmlMeta?.annotation?.object[i]?.updatedName?._text ? xmlMeta?.annotation.object[i].updatedName._text : xmlMeta?.annotation?.object[i]?.name?._text,
          isDraft: xmlMeta?.annotation?.object[i]?.draftUpdatedName?._text ? xmlMeta?.annotation?.object[i]?.draftUpdatedName?._text : false,
          bounds: await eveluateXMLBounds(xmlMeta?.annotation?.object[i]?.bndbox)// evaluate height,width, xmin and ymin coordinates
        }

        let { intesr, flag } = await boundsIsOverlap(newObj);// compare overlap bounds with json 

        let box_A = [newObj.bounds.xmin, newObj.bounds.ymin, newObj.bounds.xmax, newObj.bounds.ymax]
        for (let subbLp = 0; subbLp < intesr.length; subbLp++) {
          let box_B = [intesr[subbLp].xmin, intesr[subbLp].ymin, intesr[subbLp].xmax, intesr[subbLp].ymax]
          let x_low = Math.max(box_A[0], box_B[0])
          let y_low = Math.max(box_A[1], box_B[1])
          let x_high = Math.min(box_A[2], box_B[2])
          let y_high = Math.min(box_A[3], box_B[3])
          let inter_area = Math.max(0, x_high - (x_low + 1)) * Math.max(0, y_high - y_low + 1)
          let box_B_area = (box_B[2] - (box_B[0] + 1)) * (box_B[3] - (box_B[1] + 1))
          let intersectedArea = inter_area / box_B_area
          intesr[subbLp].intersectedArea = intersectedArea



        }



        for (let k = 0; k < tempNewObject?.overlap?.length; k++) {
          let newInd = intesr.findIndex((item) => item.text === tempNewObject?.overlap[k].text)

          if (newInd > -1) {
            // console.log("intersection point matched --->", tempNewObject.overlap[k].intersectedArea, intesr[newInd])
            if (tempNewObject.overlap[k].intersectedArea < 0.5) {
              tempNewObject.overlap.splice(k, 1)
            }
            if (intesr[newInd].intersectedArea < 0.5) {
              intesr.splice(newInd, 1)
            }
          }
        }

        newObj.overlap = intesr;
        let flag1 = true
        // for (var z = 0; z < xmlTagsEveluted?.length; z++) {

        //   let intersectdata = xmlTagsEveluted[z] && xmlTagsEveluted[z].overlap.filter(item => item.id === intesr[0]?.id);
        //   if (intersectdata && intersectdata.length > 0) {
        //     flag1 = false

        //   }
        // }
        if (flag1) {

          if (xmlTagsEveluted.length > 1) {
            xmlTagsEveluted[xmlTagsEveluted.length - 1] = tempNewObject
          }
          xmlTagsEveluted.push(newObj);
        }
        else {
          xmlTagsEveluted.push(newObj);
        }
        if (flag1 == false) {
          // console.log('value is false', newObj)
          // break;
        }
        tempNewObject = newObj
      }
    }

    _xmlTags(prevState => prevState = [...xmlTagsEveluted]);
    setXmlTags(prevState => prevState = [...xmlTagsEveluted]);
    cb(xmlTagsEveluted)


  }

  /**
      * @description function get xml file data and eveluate 
      */
  const eveluateXML = async () => {
    // console.log('abcde',is_multi_loan,Object.keys(xmlMeta).length)
    let xmlTagsEveluted = [];
    if (xmlMeta && Object.keys(xmlMeta).length) {
      console.log('abcdef',is_multi_loan)
      // change for no xml response doc
      if (!xmlMeta?.annotation?.object?.length) {
        let value = xmlMeta?.annotation?.object;
        xmlMeta.annotation.object = [];
        xmlMeta.annotation.object.push(value)
      }
      let tempNewObject;
      for (var i = 0; i < xmlMeta?.annotation.object.length; i++) {

        if (is_multi_loan) {

          console.log('abcdefg',is_multi_loan)
          // console.log('xmlMeta?.annotation.object[i].bndbox',xmlMeta?.annotation.object[i].bndbox)


          if (xmin <= xmlMeta?.annotation.object[i].bndbox.xmin._text && xmlMeta?.annotation.object[i].bndbox.xmax._text <= xmax && y <= xmlMeta?.annotation.object[i].bndbox.ymax._text) {



            let newObj = {
              id: `${xmlMeta?.annotation?.object[i]?.name._text}:${i}`, // this id use to maintain while fouse on any files hilight bounds on same index
              updatedAt: xmlMeta?.annotation.object[i]?.updatedAt || false,
              changesViaVersion: xmlMeta?.annotation.object[i]?.changesViaVersion || false,
              tagId: `${i}:${pageNumber}`,
              tag: xmlMeta?.annotation?.object[i]?.updatedName?._text ? xmlMeta?.annotation.object[i].updatedName._text : xmlMeta?.annotation?.object[i]?.name?._text,
              isDraft: xmlMeta?.annotation?.object[i]?.draftUpdatedName?._text ? xmlMeta?.annotation?.object[i]?.draftUpdatedName?._text : false,
              bounds: await eveluateXMLBounds(xmlMeta?.annotation?.object[i]?.bndbox)// evaluate height,width, xmin and ymin coordinates
            }

            let { intesr, flag } = await boundsIsOverlap(newObj);// compare overlap bounds with json 

            let box_A = [newObj.bounds.xmin, newObj.bounds.ymin, newObj.bounds.xmax, newObj.bounds.ymax]

            for (let subbLp = 0; subbLp < intesr.length; subbLp++) {
              console.log("intesr",intesr[subbLp])
              let box_B = [intesr[subbLp].xmin, intesr[subbLp].ymin, intesr[subbLp].xmax, intesr[subbLp].ymax]
              let x_low = Math.max(box_A[0], box_B[0])
              let y_low = Math.max(box_A[1], box_B[1])
              let x_high = Math.min(box_A[2], box_B[2])
              let y_high = Math.min(box_A[3], box_B[3])
              let inter_area = Math.max(0, x_high - (x_low + 1)) * Math.max(0, y_high - y_low + 1)
              let box_B_area = (box_B[2] - (box_B[0] + 1)) * (box_B[3] - (box_B[1] + 1))
              let intersectedArea = inter_area / box_B_area
              intesr[subbLp].intersectedArea = intersectedArea



            }



            for (let k = 0; k < tempNewObject?.overlap?.length; k++) {
              let newInd = intesr.findIndex((item) => item.text === tempNewObject?.overlap[k].text)

              if (newInd > -1) {
                // console.log("intersection point matched --->", tempNewObject.overlap[k].intersectedArea, intesr[newInd])
                if (tempNewObject.overlap[k].intersectedArea < 0.5) {
                  tempNewObject.overlap.splice(k, 1)
                }
                if (intesr[newInd].intersectedArea < 0.5) {
                  intesr.splice(newInd, 1)
                }
              }
            }

            newObj.overlap = intesr;
            let flag1 = true
            for (var z = 0; z < xmlTagsEveluted?.length; z++) {

              let intersectdata = xmlTagsEveluted[z] && xmlTagsEveluted[z].overlap.filter(item => item.id === intesr[0]?.id);
              if (intersectdata && intersectdata.length > 0) {
                flag1 = false

              }
            }
            if (flag1) {

              if (xmlTagsEveluted.length > 1) {
                xmlTagsEveluted[xmlTagsEveluted.length - 1] = tempNewObject
              }
              xmlTagsEveluted.push(newObj);
            }
            else {
              xmlTagsEveluted.push(newObj);
            }
            if (flag1 == false) {
              // console.log('value is false', newObj)
              // break;
            }
            tempNewObject = newObj


          }

        } else {

          let newObj = {
            id: `${xmlMeta?.annotation?.object[i]?.name._text}:${i}`, // this id use to maintain while fouse on any files hilight bounds on same index
            updatedAt: xmlMeta?.annotation.object[i]?.updatedAt || false,
            changesViaVersion: xmlMeta?.annotation.object[i]?.changesViaVersion || false,
            tagId: `${i}:${pageNumber}`,
            tag: xmlMeta?.annotation?.object[i]?.updatedName?._text ? xmlMeta?.annotation.object[i].updatedName._text : xmlMeta?.annotation?.object[i]?.name?._text,
            isDraft: xmlMeta?.annotation?.object[i]?.draftUpdatedName?._text ? xmlMeta?.annotation?.object[i]?.draftUpdatedName?._text : false,
            bounds: await eveluateXMLBounds(xmlMeta?.annotation?.object[i]?.bndbox)// evaluate height,width, xmin and ymin coordinates
          }

          let { intesr, flag } = await boundsIsOverlap(newObj);// compare overlap bounds with json 

          let box_A = [newObj.bounds.xmin, newObj.bounds.ymin, newObj.bounds.xmax, newObj.bounds.ymax]

          for (let subbLp = 0; subbLp < intesr.length; subbLp++) {
            let box_B = [intesr[subbLp].xmin, intesr[subbLp].ymin, intesr[subbLp].xmax, intesr[subbLp].ymax]
            let x_low = Math.max(box_A[0], box_B[0])
            let y_low = Math.max(box_A[1], box_B[1])
            let x_high = Math.min(box_A[2], box_B[2])
            let y_high = Math.min(box_A[3], box_B[3])
            let inter_area = Math.max(0, x_high - (x_low + 1)) * Math.max(0, y_high - y_low + 1)
            let box_B_area = (box_B[2] - (box_B[0] + 1)) * (box_B[3] - (box_B[1] + 1))
            let intersectedArea = inter_area / box_B_area
            intesr[subbLp].intersectedArea = intersectedArea



          }



          for (let k = 0; k < tempNewObject?.overlap?.length; k++) {
            let newInd = intesr.findIndex((item) => item.text === tempNewObject?.overlap[k].text)

            if (newInd > -1) {
              // console.log("intersection point matched --->", tempNewObject.overlap[k].intersectedArea, intesr[newInd])
              if (tempNewObject.overlap[k].intersectedArea < 0.5) {
                tempNewObject.overlap.splice(k, 1)
              }
              if (intesr[newInd].intersectedArea < 0.5) {
                intesr.splice(newInd, 1)
              }
            }
          }

          newObj.overlap = intesr;
          let flag1 = true
          for (var z = 0; z < xmlTagsEveluted?.length; z++) {

            let intersectdata = xmlTagsEveluted[z] && xmlTagsEveluted[z].overlap.filter(item => item.id === intesr[0]?.id);
            if (intersectdata && intersectdata.length > 0) {
              flag1 = false

            }
          }
          if (flag1) {

            if (xmlTagsEveluted.length > 1) {
              xmlTagsEveluted[xmlTagsEveluted.length - 1] = tempNewObject
            }
            xmlTagsEveluted.push(newObj);
          }
          else {
            xmlTagsEveluted.push(newObj);
          }
          if (flag1 == false) {
            // console.log('value is false', newObj)
            // break;
          }
          tempNewObject = newObj


        }
      }
      if (scale == 1) {
        _xmlTags(prevState => prevState = [...xmlTagsEveluted]);
      }
    }

    // _xmlTags(prevState => prevState = [...xmlTagsEveluted]);
    setXmlTags(prevState => prevState = [...xmlTagsEveluted]);



  }


  /**
 * @description Function getting canvas context
 * @param {Number} value accepting width and height
 * @returns return canvas context
 */
  const create2dContext = (width, height) => {
    // console.log(width, height, scale, "checking in docview")

    const canvas = document.getElementById("doc-canvas");
    let tipCanvasDoc = document.getElementById("tip-doc");
    // console.log(tipCanvasDoc, "tipCanvasDoctipCanvasDoctip------")
    let tipCtxDocView = tipCanvasDoc.getContext("2d");
    // console.log(tipCtxDocView, "Checking tipCtxDocView--->>>")
    canvas.width = width;
    canvas.height = height;
    setTipCtx(tipCtxDocView)
    setCanvasDocView(canvas)
    setCanvas(canvas)
    setTipCanvas(tipCanvasDoc)
    return canvas.getContext("2d");
  };

  /**
   * 
   * This is function check latest version of the file and return boolean value
   */

  // let getLatestVersion = () => {
  //   if (fileData?.version == Number(_currentVersion) || !_currentVersion || fileData?.version == Number(latestVersion)) {
  //     return true
  //   }
  //   else {
  //     return false
  //   }
  // }

  /**
  * @description method call to disply tooltip 
  * @param {*} value  text which need to display in tooltip
  * @param {*} mouse current mouse event 
  */
  const toolTipDraw = (value, mouse,) => {
    // alert(value)
    tipCanvas.style.display = "block";
    tipCanvas.style.pointerEvents = "none";
    let tagTxt = 'Tag Name:'
    tipCanvas.width = tipCtx.measureText(tagTxt).width + tipCtx.measureText(value).width + 10;
    let left;
    // console.log('sadasdd', mouse.clientX, tipCanvas.width)
    if ((mouse.clientX - tipCanvas.width - 340 - 40) > 0) {
      left = (mouse.clientX - tipCanvas.width - 340 - 40)
    } else {
      left = mouse.clientX - 340 + 40;
    }
    tipCanvas.style.left = left + "px";
    tipCanvas.style.top = (mouse.clientY - 103) + "px";
    tipCtx.fillStyle = 'white'
    tipCtx.clearRect(0, 0, tipCanvas.width, tipCanvas.height);
    tipCtx.fillText(`${tagTxt}`, 5, 15);
    tipCtx.fillText(`${capitalizeFirstLetter(value)}`, 55, 15);
  }


  /**
     * @description function use for show toltip  on mousehover
     */
  const enventRectOld = (callBack) => {

    canvasDocView.onclick = async (e) => {

      if (Object.keys(xmlMetaDetailObject).length && xmlMetaDetailObject[pageNumber].annotation.object) {


        if (data?.packet_type?._id || data?.packet_type) {
          // console.log(_currentVersion, latestVersion, "all three versions")
          if (fileData?.version == Number(_currentVersion) || !_currentVersion || fileData?.version == Number(latestVersion)) {
            // console.log(fileData?.version, Number(_currentVersion), _currentVersion, fileData?.version == Number(_currentVersion), "0" == false, "cvbdvfcgvcgd---")
            setLoader(true)
            setTagValue("")
            canvasContext.clearRect(0, 0, 700, 500);
            if (pdf?.img)
              await decodeImg(pdf);
            else
              await decodePdf(pdf);
            var cvsoffset = canvasDocView.getBoundingClientRect();
            var mouseX = parseInt(e.clientX - cvsoffset.x);
            var mouseY = parseInt(e.clientY - cvsoffset.y);
            // console.log(xmlTags, "this is xmltags--->>>>>>");
            xmlTags.forEach((item) => {
              if (hit(item.bounds, mouseX, mouseY, scale)) { // check current mouse cursor position and show tooltip on pdf
                // toolTipDraw(item.tag, e)
                // hits = true
                setExistingTagBounds(item.bounds)
                setTagValue(item?.tag)
                // return false;
              }
              // if (!hits)
              //     tipCanvas.style.display = "none";
            })
            // console.log(jsonMetaData, "jsonMetaData")
            jsonMetaData.text.forEach((item, i) => {


              let jsItm = {

                x: scaleJsonCal(jsonMetaData.left[i]), // scaleJsonCal function use to set zoom in/out coordinates
                y: scaleJsonCalHeight(jsonMetaData.top[i]),
                w: scaleJsonCal(jsonMetaData.width[i]),
                h: scaleJsonCalHeight(jsonMetaData.height[i]),

                /* given xmin is starting point and x max is the width-17Jan-22*/
                xmin: { _text: Number(jsonMetaData.left[i]) },
                xmax: { _text: + Number(jsonMetaData.left[i]) + Number(jsonMetaData.width[i]) },
                ymin: { _text: Number(jsonMetaData.top[i]) },
                ymax: { _text: + Number(jsonMetaData.top[i]) + Number(jsonMetaData.height[i]) },
                text: jsonMetaData.text[i],
                confidence: jsonMetaData.confidence[i]


              }

              if (jsItm && hit(jsItm, mouseX, mouseY, scale)) { // check current mouse cursor position and show tooltip on pdf
                // console.log(item, hit(jsItm, mouseX, mouseY, scale), jsonMetaData.left[i], jsonMetaData.width[i], "checking json item in if block------>>>>>>")
                // setLoader(false)

                setOpenModal(true)
                setEditXmlTag(jsItm)
                //  boundsDraw()
                //return false;

                // console.log(jsItm, "checking jsItem")

              } else {
                // console.log(item, "checking json item in else block------>>>>>>")
                //   boundsDraw()
                // console.log(jsItm, item, "elseeeeeeeeeee this is rect event eeeeeeeeeeeeeeee--->>>>>>")
                // console.log(jsItm, mouseX, mouseY, scale, "elseeeeeee  this is rect event eeeeeeeeeeeeeeee--->>>>>>")
              }
            });
            boundsDraw();
            setLoader(false)
          }
          else {
            // console.log(fileData?.version, Number(_currentVersion), _currentVersion, fileData?.version == Number(_currentVersion), "0" == false, "cvbdvfcgvcgd else---")
            toast.error("Please switch to latest version for adding a new Tag.")
          }

        }
        else {
          toast.error("This File does not contain packet type")
        }
      }
      else {
        toast.error("This File does not contain corresponding xml tags")
      }
    }
  }
  const enventRect = (callBack) => {
    canvas.onmousemove = (e) => {
      var cvsoffset = canvas.getBoundingClientRect();
      let mouseX = parseInt(e.clientX - cvsoffset.x);
      let mouseY = parseInt(e.clientY - cvsoffset.y);
      let hits = false
      xmlTags.forEach((item) => {
        if (hit(item.bounds, mouseX, mouseY, scale)) { // check current mouse cursor position and show tooltip on pdf
          toolTipDraw(item.tag, e)
          hits = true
        }
        if (!hits)
          tipCanvas.style.display = "none";
      })
    }
    canvasDocView.onclick = async (e) => {

      if (Object.keys(xmlMetaDetailObject).length && xmlMetaDetailObject[pageNumber].annotation.object) {
        if (data?.packet_type?._id || data?.packet_type) {
          // console.log(_currentVersion, latestVersion, "all three versions")
          if (fileData?.version == Number(_currentVersion) || !_currentVersion || fileData?.version == Number(latestVersion)) {
            // console.log(fileData?.version, Number(_currentVersion), _currentVersion, fileData?.version == Number(_currentVersion), "0" == false, "cvbdvfcgvcgd---")
            setLoader(true)
            setTagValue("")
            canvasContext.clearRect(0, 0, 700, 500);
            if (pdf?.img)
              await decodeImg(pdf);
            else
              await decodePdf(pdf);
            var cvsoffset = canvasDocView.getBoundingClientRect();
            var mouseX = parseInt(e.clientX - cvsoffset.x);
            var mouseY = parseInt(e.clientY - cvsoffset.y);
            let hits = false
            // console.log(xmlTags, "this is xmltags--->>>>>>");
            xmlTags.forEach((item) => {
              if (hit(item.bounds, mouseX, mouseY, scale)) { // check current mouse cursor position and show tooltip on pdf
                // toolTipDraw(item.tag, e)
                hits = true
                let itemBounds = {
                  x: Number(item.bounds.x), // scaleJsonCal function use to set zoom in/out coordinates
                  y: scaleJsonCalHeight(item.bounds.y),
                  w: scaleJsonCal(item.bounds.w),
                  h: scaleJsonCalHeight(item.bounds.h),

                  /* given xmin is starting point and x max is the width-17Jan-22*/
                  // xmin:( Number(item.bounds.xmin)/docScale) ,
                  // xmax: Number(item.bounds.xmax) ,
                  // ymin: Number(item.bounds.ymin) ,
                  // ymax: Number(item.bounds.ymax) ,

                  xmin: Number(item.bounds.x) * scale * docScale,
                  xmax: (Number(item.bounds.x) + Number(item.bounds.w)) * scale * docScale,
                  ymin: (Number(item.bounds.y)) * scale * docScale,
                  ymax: (Number(item.bounds.y) + Number(item.bounds.h)) * scale * docScale,
                }
                // setExistingTagBounds(item.bounds)
                setExistingTagBounds(itemBounds)
                setTagValue(item?.tag)
                setOriginalTagValue(item?.tag)
                // return false;
                // console.log(data.assignedTo ,"==", userDetail._id ,"||", !setDisable)
                // console.log("||", setDisable)
                // if(data.assignedTo == userDetail._id || !setDisable){ //
                setOpenModal(true)
                // } //
                // console.log(item.bounds, "item.bounds")
                // setEditXmlTag(item.bounds)
                setEditXmlTag(itemBounds)
                tipCanvas.style.display = "none";
              }
              // if (!hits)
              //     tipCanvas.style.display = "none";
            })
            if (!hits) {
              // console.log(hits, "checking hitsss")
              jsonMetaData.text.forEach((item, i) => {


                let jsItm = {

                  x: scaleJsonCal(jsonMetaData.left[i]), // scaleJsonCal function use to set zoom in/out coordinates
                  y: scaleJsonCalHeight(jsonMetaData.top[i]),
                  w: scaleJsonCal(jsonMetaData.width[i]),
                  h: scaleJsonCalHeight(jsonMetaData.height[i]),

                  /* given xmin is starting point and x max is the width-17Jan-22*/
                  xmin: Number(jsonMetaData.left[i]) * scale,
                  xmax: (Number(jsonMetaData.left[i]) + Number(jsonMetaData.width[i])) * scale,
                  ymin: (Number(jsonMetaData.top[i])) * scale,
                  ymax: (Number(jsonMetaData.top[i]) + Number(jsonMetaData.height[i])) * scale,
                  text: jsonMetaData.text[i],
                  confidence: jsonMetaData.confidence[i]


                }

                if (jsItm && hit(jsItm, mouseX, mouseY, scale)) { // check current mouse cursor position and show tooltip on pdf
                  // console.log(item, hit(jsItm, mouseX, mouseY, scale), jsonMetaData.left[i], jsonMetaData.width[i], "checking json item in if block------>>>>>>")
                  // setLoader(false)
                  // console.log(jsItm,scale, jsonMetaData.left[i],jsonMetaData.width[i], "this isssss json")
                  // console.log("hiotting jsonn")
                  setOpenModal(true)
                  setEditXmlTag(jsItm)
                  //  boundsDraw()
                  //return false;

                  // console.log(jsItm, "checking jsItem")

                } else {
                  // console.log(item, "checking json item in else block------>>>>>>")
                  //   boundsDraw()
                  // console.log(jsItm, item, "elseeeeeeeeeee this is rect event eeeeeeeeeeeeeeee--->>>>>>")
                  // console.log(jsItm, mouseX, mouseY, scale, "elseeeeeee  this is rect event eeeeeeeeeeeeeeee--->>>>>>")
                }
              });
            }
            // console.log(jsonMetaData, "jsonMetaData")
            // jsonMetaData.text.forEach((item, i) => {


            //   let jsItm = {

            //     x: scaleJsonCal(jsonMetaData.left[i]), // scaleJsonCal function use to set zoom in/out coordinates
            //     y: scaleJsonCalHeight(jsonMetaData.top[i]),
            //     w: scaleJsonCal(jsonMetaData.width[i]),
            //     h: scaleJsonCalHeight(jsonMetaData.height[i]),

            //     /* given xmin is starting point and x max is the width-17Jan-22*/
            //     xmin: { _text: Number(jsonMetaData.left[i]) },
            //     xmax: { _text: + Number(jsonMetaData.left[i]) + Number(jsonMetaData.width[i]) },
            //     ymin: { _text: Number(jsonMetaData.top[i]) },
            //     ymax: { _text: + Number(jsonMetaData.top[i]) + Number(jsonMetaData.height[i]) },
            //     text: jsonMetaData.text[i],
            //     confidence: jsonMetaData.confidence[i]


            //   }

            //   if (jsItm && hit(jsItm, mouseX, mouseY, scale)) { // check current mouse cursor position and show tooltip on pdf
            //     // console.log(item, hit(jsItm, mouseX, mouseY, scale), jsonMetaData.left[i], jsonMetaData.width[i], "checking json item in if block------>>>>>>")
            //     // setLoader(false)

            //     setOpenModal(true)
            //     setEditXmlTag(jsItm)
            //     //  boundsDraw()
            //     //return false;

            //     // console.log(jsItm, "checking jsItem")

            //   } else {
            //     // console.log(item, "checking json item in else block------>>>>>>")
            //     //   boundsDraw()
            //     // console.log(jsItm, item, "elseeeeeeeeeee this is rect event eeeeeeeeeeeeeeee--->>>>>>")
            //     // console.log(jsItm, mouseX, mouseY, scale, "elseeeeeee  this is rect event eeeeeeeeeeeeeeee--->>>>>>")
            //   }
            // });
            boundsDraw();
            setLoader(false)
          }
          else {
            // console.log(fileData?.version, Number(_currentVersion), _currentVersion, fileData?.version == Number(_currentVersion), "0" == false, "cvbdvfcgvcgd else---")
            toast.error("Please switch to latest version for adding a new Tag.")
          }

        }
        else {
          toast.error("This File does not contain packet type")
        }
      }
      else {
        toast.error("This File does not contain corresponding xml tags")
      }
    }
  }


  /**
   * @description Function to render PDF data over canvas
   * @returns return updated canvas
   */
  const decodePdf = async (pdf) => {




    console.log('pageNumber', pageNumber);
    const page = await pdf.getPage(parseInt(pageNumber));
    let currentPdfWidth = page.getViewport({ scale: scale }).width;
    let currentPdfHeight = await page.getViewport({ scale: scale }).height;
    const viewport = page.getViewport({ scale: scale });
    const { width, height } = viewport;
    setHeight(height);
    // console.log(width, height, "chekcing widthheight in pdff")
    let canvasContext = create2dContext(width, height);
    console.log(canvasContext,"canvasContext")
    await page.render({ canvasContext, viewport }).promise;
    // setDocScale(jsonMetaData?.analyzeResult?.readResults[0]?.width / currentPdfWidth)
    setOcrJsonScaleHeight(jsonMetaData?.page_height / currentPdfHeight)
    setDocScale(jsonMetaData?.page_width / currentPdfWidth)
    setOcrJsonScale(jsonMetaData?.page_width / currentPdfWidth)
    if (xmlMeta && xmlMeta?.annotation) {  // change for no xml response doc
      setOcrScaleHeight(xmlMeta?.annotation.size.height._text / currentPdfHeight)
    }
    setCanvasContext(canvasContext);
    _zoomFlag(false);




  };






  /**
   * @description Function to render PNG/JPG data over canvas
   * @returns return updated canvas
   */
  const decodeImg = async (imgInst) => {
    const { width, height } = imgInst;
    setHeight(height);
    // console.log(width, height, "checking width height in decode img--")
    // let canvasContext = await create2dContext(width, height);
    // canvasContext.drawImage(imgInst.img, 0, 0, width, height);
    // setDocScale(jsonMetaData?.page_width / width)
    // setOcrJsonScale(jsonMetaData?.page_width / (width * scale))
    // setOcrScaleHeight(xmlMeta.annotation.size.height._text / (height * scale))
    // setOcrJsonScaleHeight(jsonMetaData?.page_height / (height * scale))
    // setCanvasContext(canvasContext);
    // _zoomFlag(false);
    // console.log(xmlMeta.annotation.size.width._text ,width , scale, "width * scalewidth * scale" )
    let canvasContext = await create2dContext(width * scale, height * scale);
    canvasContext.drawImage(imgInst.img, 0, 0, width * scale, height * scale);
    if (Object.keys(xmlMeta).length) {  // change for no xml response doc
      setDocScale(xmlMeta.annotation.size.width._text / (width * scale))
      setOcrJsonScale(jsonMetaData?.page_width / (width * scale))
      setOcrScaleHeight(xmlMeta.annotation.size.height._text / (height * scale))
    }
    setOcrJsonScaleHeight(jsonMetaData?.page_height / (height * scale))
    setCanvasContext(canvasContext);
    _zoomFlag(false);
  }

  async function loadOptions(modifiedSearch, loadedOptions, { page }) {
    // console.log(modifiedSearch, "gdfsdfgs", removeUnderscore(tagValue.replace(/(\r\n|\n|\r)/gm, "").trim()), "kkkk")
    let response = await tagSearchAction({ packet_type: data.packet_type?._id || data?.packet_type, modifiedSearch: modifiedSearch || removeUnderscore(tagValue.replace(/(\r\n|\n|\r)/gm, "").trim()) || "optionNotFound", page })
    // let response = await tagSearchAction({ modifiedSearch: modifiedSearch || selectedTag.replace(/(\r\n|\n|\r)/gm, "").trim(), page })
    // let response = await tagSearchAction({ modifiedSearch: modifiedSearch, page });
    // console.log(response, modifiedSearch, removeUnderscore(tagValue.replace(/(\r\n|\n|\r)/gm, "").trim()), tagValue, "checking response in option function")
    console.log(response, 'data?.packet_type?._id', data?.packet_type?._id, 'data?.packet_type', data?.packet_type, "chekcing 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")
    if (!response.docs.length)
      setMsg('No Options')
    return {
      options: response.docs,
      // hasMore: response.hasNextPage,
      hasMore: response?.docs?.length > 0 ? response.hasNextPage : false,
      additional: {
        page: page + 1,
      },

    };
  }

  const [msg, setMsg] = useState('Start typing here....')
  const getMsg = () => {
    return msg
  }
  // const [activeLink, setActiveLink] = useState(null);
  // const [editTabsVal, setEditTabsVal] = useState();
  // const [zoomOcr, setZoomOcr] = useState(false);
  // const [defaultScale, setDefaultScale] = useState(getDefaultScale(window.innerWidth));
  // const [fieldPriority, setFieldPriority] = useState(false);
  // const [reloadOcr, setReloadOcr] = useState(false);
  // const [priorityFlag, setPriorityFlag] = useState(false);
  // const [disabledZoomOutButton, setDisabledZoomOutButton] = useState(true);
  // const [disabledZoomInButton, setDisabledZoomInButton] = useState(false);
  // const [disabledZoomFlag, setDisabledZoomFlag] = useState(false);
  // const [activeEditTabs, setActiveEditTabs] = useState('1');

  const myRef = React.createRef(null);
  /**
 * @description function trigger when click on zoom in(+) ocr view 
 * @param {*} val scale value
 */
  // const _zoomInOcr = (val) => {
  //   // console.log(typeof (val), "chercking zoom1111111")
  //   setDisabledZoomOutButton(false);
  //   setActiveLink(val);
  //   let scal = parseFloat(defaultScale + 1);
  //   if (scal <= maxScaleValue) {
  //     setDisabledZoomFlag(true);
  //     setDefaultScale(parseFloat(scal));
  //     setZoomOcr(parseFloat(scal))
  //     if (parseFloat(scal + 1) >= maxScaleValue) {
  //       setDisabledZoomInButton(true);
  //       setActiveLink(null)
  //     }
  //   }

  // }

  /**
 * @description function trigger when click on zoom out(-) ocr view 
 * @param {*} val scale value
 */
  // const _zoomOutOcr = (val) => {
  //   setActiveLink(val);
  //   setDisabledZoomInButton(false);
  //   let scal = parseFloat(defaultScale - 1).toFixed(1);
  //   if (scal >= getDefaultScale(window.innerWidth)) {
  //     setDisabledZoomFlag(true);
  //     setDefaultScale(parseFloat(scal));
  //     setZoomOcr(parseFloat(scal))
  //     if (parseFloat(scal) === parseFloat(getDefaultScale(window.innerWidth))) {
  //       setDisabledZoomOutButton(true);
  //       setActiveLink(null);
  //     }
  //   }

  // }

  // const _refresh = (tab = true) => {
  //   setActiveLink(null);
  //   setEditTabsVal()
  //   setZoomOcr(getDefaultScale(window.innerWidth))
  //   setDefaultScale(getDefaultScale(window.innerWidth));
  //   setFieldPriority(false)
  //   setReloadOcr(tab);
  //   setPriorityFlag(false);
  //   setDisabledZoomOutButton(true);
  //   setDisabledZoomInButton(false);
  //   if (myRef.current)
  //     myRef.current.scrollTo(0, 0);
  // };

  return (<>

    {/* {console.log(_currentVersion, fileData?.version, latestVersion, "checking vwersion version")} */}
    <Modal isOpen={(openModal && data?.packet_type?._id) || (openModal && data?.packet_type)} className="success-popup">
      <ModalHeader>Add / Update Tag
        <Button color='link' disabled={loader} onClick={() => { setOpenModal(false); setFocus(false); setDisableButton(true) }} >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="34"
            viewBox="0 0 34 34"
          >
            <g data-name="Group 651" transform="translate(-1535 -134)">
              <g
                fill="#fff"
                stroke="#000"
                strokeWidth="2"
                data-name="Ellipse 30"
                opacity="0.3"
                transform="translate(1535 134)"
              >
                <circle cx="17" cy="17" r="17" stroke="none"></circle>
                <circle cx="17" cy="17" r="16" fill="none"></circle>
              </g>
              <path
                d="M19.589 18l4.8-4.8a1.124 1.124 0 00-1.589-1.584l-4.8 4.8-4.8-4.8a1.124 1.124 0 10-1.584 1.584l4.8 4.8-4.8 4.8a1.124 1.124 0 001.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 101.584-1.584z"
                data-name="Icon ionic-ios-close"
                opacity="0.3"
                transform="translate(1534.289 132.789)"
              ></path>
            </g>
          </svg>
        </Button>
      </ModalHeader>
      <ModalBody className="dimension" style={{ height: ` ${focus ? "350px" : "auto"}  ` }}>
        {
          loader && <LoaderUI message={true} FullWindow={false} inContainer={true} loadingMessage={"Saving Tag..."} />
        }
        {!unableToValidate ? <Input type="text" name="firstDigit" disabled={true} value={tagValue} onChange={(e) => setTagValue(e.target.value)} /> :
          <div className={'flex-class'}>
            <AsyncPaginate
              name="Tagfrm"
              id={tagValue}
              onChange={(e) => { setTagValue(e.tagName); setDisableButton(false) }}
              onClick={() => { }}
              placeholder={removeUnderscore(tagValue) || 'Start typing here....'}
              loadOptions={loadOptions}
              getOptionLabel={(e) => e.tagName}
              defaultValue={removeUnderscore(tagValue)}
              onFocus={() => setFocus(true)}
              key={tagValue}
              // menuIsOpen={true}
              additional={{
                page: 1,
              }}
              noOptionsMessage={() => getMsg()}
              // selectRef={el => refs.current[item?.id + "tag"] = el}
              styles={{
                option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                  return {
                    ...styles, backgroundColor: isFocused ? "#999999" : null, color: "#333333"

                  }
                },
                menu: (styles, { data, isDisabled, isFocused, isSelected }) => {
                  return {
                    ...styles, height: "250px"

                  }
                },
                menuList: (styles, { data, isDisabled, isFocused, isSelected }) => {
                  return {
                    ...styles, height: "100%", maxHeight: "none"
                  }
                }

              }}
              // key={tagValue}
              className={'async-input'}

            // className={`${_focus?.id + "tag" === item?.id + "tag" ? 'input-tag-thighlight-tag' : ''} react-select-container`}
            // classNamePrefix="react-select-custom"

            />
            <Button color='link' className="btn btn-secondary btn-shift" onClick={() => { insertNewTag(editXmlTag); setFocus(false) }} disabled={disableButton}>Save</Button>
          </div>}
      </ModalBody>
    </Modal>
    <div>
      <div className="file-version-blc d-inline-flex align-items-center text-start">
        {/* <div className="flex-class p-1"> */}
        <div className="left-col">
          <a href="#" className='lbl'>
            {fileData?.folder?.loan_number}
          </a>

          <span className="arrow-icon">
            &raquo;
          </span>
          <label className='des'>
            {fileData?.name}
          </label>
        </div>
        <div className="right-col ms-auto">
          <label>
            <span>
              By:
            </span>

            {latestFileVersion?.user ? (latestFileVersion?.user?.fname + " " + latestFileVersion?.user?.lname) : (latestFileVersion?.admin?.fname + " " + latestFileVersion?.admin?.lname)}
            {/* {console.log("latestVersion", latestFileVersion?.user, latestFileVersion?.admin)} */}

          </label>
          <label>
            <span>
              On:
            </span>
            {
              (latestFileVersion?.updatedAt && userDetail?.timezone) ? <><TimezoneClock timezone={userDetail.timezone} dateTime={latestFileVersion?.updatedAt} timeFormat={"MMM DD,YYYY"} /> at <TimezoneClock timezone={userDetail.timezone} dateTime={latestFileVersion?.updatedAt} timeFormat={"h:mm a"} /></> :
                moment(latestFileVersion?.updatedAt).format(
                  "MMM DD,YYYY"
                ) + ' at ' + moment(latestFileVersion?.updatedAt).format(
                  "h:mm a"
                )}

          </label>
        </div>
      </div>
      {/* {console.log(xmlTags, jsonMetaData, "checking filedata-------")} */}
    </div>
    <div className={`inner flex-fill overflow-auto`}>
      {/* {console.log(scale,docScale,"checking files in doc-view")} */}
      <canvas id="tip-doc" className="tip-doc" ref={canvasRefDoc} width="300" height="25"></canvas> <canvas width="600" height="800" id="doc-canvas"></canvas>
    </div>
  </>);
};

export default DocumentFileView;
